export enum SelectOptionsPositionEnum {
    Left = 1,
    Right
}
